
import { useState } from 'react';

interface HeaderProps {
  isScrolled: boolean;
}

export default function Header({ isScrolled }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-[0_1px_3px_rgba(0,0,0,0.05)]' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-16 xl:px-24">
        <div className="flex items-center justify-between h-24 sm:h-28 md:h-32">
          <div className="flex items-center">
            <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="cursor-pointer">
              <img
                src="https://static.readdy.ai/image/80932669f31e28b86429da114025ac51/08dec07d3c53a8364cfccdbeb3d31cd3.png"
                alt="Naturi"
                className="h-20 sm:h-24 md:h-28 lg:h-32 w-auto"
              />
            </button>
          </div>

          <nav className="hidden md:flex items-center gap-8 lg:gap-10">
            <button
              onClick={() => scrollToSection('services')}
              className="text-[0.8rem] sm:text-sm font-light tracking-wider transition-colors cursor-pointer whitespace-nowrap text-gray-600 hover:text-[#6b8e6b]"
            >
              Service
            </button>
            <button
              onClick={() => scrollToSection('why-choose-us')}
              className="text-[0.8rem] sm:text-sm font-light tracking-wider transition-colors cursor-pointer whitespace-nowrap text-gray-600 hover:text-[#6b8e6b]"
            >
              Why Choose Us
            </button>
            <button
              onClick={() => scrollToSection('company')}
              className="text-[0.8rem] sm:text-sm font-light tracking-wider transition-colors cursor-pointer whitespace-nowrap text-gray-600 hover:text-[#6b8e6b]"
            >
              Team
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[0.8rem] sm:text-sm font-light tracking-wider transition-colors cursor-pointer whitespace-nowrap text-gray-600 hover:text-[#6b8e6b]"
            >
              Contact
            </button>
          </nav>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl text-gray-700`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-sm border-t border-gray-100">
          <nav className="container mx-auto px-4 py-5 flex flex-col gap-4">
            <button
              onClick={() => scrollToSection('services')}
              className="text-[0.8rem] font-light tracking-wider text-left py-1.5 text-gray-600 hover:text-[#6b8e6b] cursor-pointer"
            >
              Service
            </button>
            <button
              onClick={() => scrollToSection('why-choose-us')}
              className="text-[0.8rem] font-light tracking-wider text-left py-1.5 text-gray-600 hover:text-[#6b8e6b] cursor-pointer"
            >
              Why Choose Us
            </button>
            <button
              onClick={() => scrollToSection('company')}
              className="text-[0.8rem] font-light tracking-wider text-left py-1.5 text-gray-600 hover:text-[#6b8e6b] cursor-pointer"
            >
              Team
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[0.8rem] font-light tracking-wider text-left py-1.5 text-gray-600 hover:text-[#6b8e6b] cursor-pointer"
            >
              Contact
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
